import React from 'react';
import { KTSVG, toAbsoluteUrl } from '../../../utils';
import { Title } from '../page-components/Title';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { Spinner } from '../../Spinner';
import { IEventType } from '../../../store/merchnts/merchant-interfaces';
import clsx from 'clsx';

interface IWebhookCreateComponentBodyProps {
	availableEvents: IEventType[];
	subscribedEvent: IEventType;
	onAvailableEventClick: (event: IEventType) => void;
	onSubscribedEventClick: (e: any) => void;
	isState?: boolean;
}

export const WebhookCreateComponentBody = (props: IWebhookCreateComponentBodyProps): JSX.Element => {
	const {
		availableEvents,
		onAvailableEventClick,
		subscribedEvent,
		onSubscribedEventClick,
		isState
	} = props;
	const { t } = useTranslation();
	const { merchantState: { isWebhookEventTypesLoading }} = useMerchants();


	if (isWebhookEventTypesLoading) {
		return <Spinner pageLoader/>;
	}

	const renderEvents = (): JSX.Element[] | JSX.Element => {
		if (availableEvents.length) {
			return availableEvents.map((event) => (
				<div
					key={event.id}
					id={event.id}
					className={clsx('mb-5 d-flex justify-content-between py-2 px-2 py-sm-3 px-sm-4 rounded-2 eventName-box', !isState && 'cursor-pointer div-hover')}
					onClick={(): void => !isState && onAvailableEventClick(event)}
				>
					<div className="fw-bold">
						{event.eventName}
					</div>
					<KTSVG path={toAbsoluteUrl('/media/icons/arrow-right.svg')} className="svg-arrow"/>
				</div>
			));
		} else {
			return <Title title={t('WEBHOOKS.NO_EVENTS')} additionalClass="fs-5 mt-20 mb-20"/>;
		}
	};

	return (
		<div className="d-flex justify-content-between mt-10">
			<div className="" style={{ width: '45%' }}>
				<div className="fs-4 mb-6">
					{t('WEBHOOKS.AVAILABLE_EVENTS')}
				</div>

				{renderEvents()}

			</div>

			<div style={{ width: '45%' }}>
				<Title title={t('WEBHOOKS.SUBSCRIBED_EVENT')} additionalClass="fs-4 mb-6"/>
				{
					Boolean(subscribedEvent?.id) && (
						<div
							key={subscribedEvent.id}
							id={subscribedEvent.id}
							className={clsx('mb-5 d-flex align-items-center py-2 px-2 py-sm-3 px-sm-4 rounded-2 eventName-box', !isState && 'cursor-pointer div-hover')}
							onClick={(e): void => !isState && onSubscribedEventClick(e)}
						>
							<KTSVG path={toAbsoluteUrl('/media/icons/arrow-right.svg')}
							       className="svg-arrow rotate-180 me-2 "/>
							<div className="fw-bold">
								{subscribedEvent?.eventName}
							</div>
						</div>
					)
				}
			</div>
		</div>
	);
};
